export default __webpack_public_path__ + "static/media/footer-rebrand-horizontal.f152b346.svg";